/**
 @author hjj
 @date 2020/6/4 7:53 下午
 */

import store from '@/store';
import Vue from 'vue'
import {comLegend, comColor,openInfoWin,closeInfoWin} from "../../script/comChart";
import {getOption} from '@/assets/axios/mapAxio'
import {clickDown,renderEvent} from "../../script/comMap"
import jsonVal from "./json/data.json";
let vm = new Vue();
let vuex = store.state;
export default {
    //类型
    type: '3Dmap',
    //类别
    class: 'chart',
    //组件名称
    name: '3D地图',
    //排序
    sort: 13,
    //是否在多维分析展示
    viewType:true,
    //图标
    iconImg: '/img/3Dmap.png',
    //基础配置
    option: {
        //最小维度数量
        minWDLength: 2,
        //最小度量数量
        minDLLength: 1,
        //最大维度数量
        maxWDLength: 2,
        //最大度量数量
        maxDLLength: 2,
        //高
        dp_height: 200,
        //宽
        dp_wight: 300,
        //最小高
        dp_min_height: 50,
        //最小宽
        dp_min_wight: 50,
        //是否展示维度配置
        isWdConfig: true,
        //是否展示度量配置
        isDlConfig: true,
        //是否展示JSON配置
        isJSONConfig: true,
        //是否展示公共配置
        isComConfig: true,
        //是否展示边框
        isComBorder: true,
    },
      // 子集展示的配置项
    chilCharts: [
        {
            name: 'charts',
            ordImg: '/img/3Dmap.png',
            bigImg:  '/img/3Dmap.png',
            //默认配置
            chartParam: {
            },
            wdParam: {},
            dlParam: {
                stack: ''
            },
            //提示
            viewDpPrompt: '维度按拖拽顺序，第一个是经度，第二个是纬度',
        }, {
            name: 'GIS',
            ordImg: '/img/map3D.png',
            bigImg: '/img/map3D.png',
            //默认配置
            chartParam: {
            },
            wdParam: {},
            dlParam: {
                stack: ''
            },
            //提示
            viewDpPrompt: '维度按拖拽顺序，第一个是经度，第二个是纬度',
        },
    ],
    //维度组件
    wdComponent: null,
    //维度配置参数
    wdHandle(option) {
        return {}
    },
    //度量组件
    dlComponent: null,
     //度量参数
    dlHandle(option) {
        return {
            //堆叠
            stack: '',
            //颜色
            color: '',
            //自定义
            customColor: false,
            //数值
            label: {
                show: false,
            },
            //主次轴
            lTAxis: 0,
        }
    },
    //右侧图表配置参数
    params(option) {
        return {
            //图例配置
            legend: {
                show: true,
                position: 'top',
                //字体
                font: {
                    color: vuex.dpType === 1 ? '#fff' : '#333',
                    size: 14,
                },
                 //间隔
                marInterval:10,
            },
            map:{
                label: {
                    show: false ,
                    color: "#fff" ,
                    fontSize: 12 ,
                    backgroundColor: 'rgba(0,23,11,0)'
                },
                zoom:1,
                mapinfo:{},
                name:'全国',
                id:100000,
                color:'rgb(5,101,123)',
                itemStyle:{
                    borderColor: "rgb(62,215,213)", //省市边界线
                    areaColor:'rgb(5,101,123)',
                    shadowColor: 'rgba(166, 230, 236, 0.6)',
                    shadowOffsetX: 0,
                    shadowOffsetY: 0,
                    shadowBlur: 10
                },
                viewControl:{
                    // projection: 'perspective' ,
                    distance: 100 ,
                    alpha: 40 ,
                    beta: 0 ,
                    autoRotate: true ,
                    autoRotateDirection:'cw' ,
                    autoRotateSpeed: 10,
                    targetCoord: [0, 0],
                    animation: true ,
                    autoRotateAfterStill: 3 ,
                },
                mapStyle:'darkblue',
                emphasis:{
                    itemStyle:{
                        areaColor:'#ccc'
                    }
                },
                amapMap:{
                    zoom: 5.5,
                    center: '110,33', //中心点
                }
            },
            visualMap: {
                show: true,
                type: 'piecewise' ,
                splitNumber:5,
                min: 0,
                max: 1000,
                top: 0,
                right:  0,
                left:0,
                bottom: 0,
                showLabel:true,
                textStyle: {
                    color: vuex.dpType === 1 ? '#fff' : '#333',
                },
                showtext:true,
                inverse:false,
                inRange:{
                    color: ['#5b9fbf', '#5bbfa2', '#5bbf67', '#7abf5b', '#a6bf5b', '#bfab5b', '#e1aa52', '#d3a589', '#d69085', '#d98d8d']
                },
                showpieces:false,
                pieces:[]
            },
            tooltip:{
                show: true ,
                backgroundColor: 'rgba(50,50,50,0.7)' ,
                borderColor: '' ,
                borderWidth: 0 ,
                padding: 5 ,
                textStyle: {
                    color: '#fff' ,
                    fontSize: 14 ,
                }
            },
        }
    },
    //右侧图表配置组件列表
    configModule: [
        {
            name: '地图配置',
            component: () => import('../../comConfig/comMap/comMap.vue')
        },
        {
            name: '地图视角配置',
            component: () => import('../../comConfig/viewControl/viewControl.vue')
        },
        {
            name: '弹板配置',
            component: () => import('../../comConfig/comTooltip/comTooltip.vue')
        },

    ],
    //接口
    JSONData: {
        //静态数组
        listDaVal: jsonVal,
        //接口参数
        params: {
            //维度
            wd: ['维度1','维度2'],
            //度量
            dl: ['度量1','度量2']
        },
        //引用的组件
        jsonPonent: () => import('./json/json'),
    },
    //静态转换数据回调
    JSONRender(json, chart, nowChart, viewDP) {
        try {
            let setChart = chart.setting;
            let params = nowChart.comParam.JSONData.params;
            let dl = params.dl;
            let wd = params.wd;
            let dlStyParam = setChart.dlStyParam;
            let wdStyParam = setChart.wdStyParam;
            let head = {
                listWD: [],
                listZB: []
            };
            let dt = JSON.parse(json);
            wd.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.wdList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listWD.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comWDConfig)),
                        params: JSON.parse(JSON.stringify(wdStyParam[index] || nowChart.comPonent.wdParams))
                    };
                    data.config.alias = item;
                    setChart.wdList.push(data)
                }
            });
            dl.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.dlList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listZB.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comDLConfig)),
                        params: JSON.parse(JSON.stringify(dlStyParam[index] || nowChart.comPonent.dlParams))
                    };
                    data.config.alias = item;
                    setChart.dlList.push(data)
                }
            });
            let JkData = {
                dataTabel: {
                    dt: dt,
                    head: head
                },
                totalCount: dt.length
            };
            chart.data = JkData;
        } catch (e) {
            chart.data = {};
        }
    },
    //图表渲染之前
    renderBefore(chart, nowChart,dom) {
        let echart = echarts.init(dom);
        echart.dispose()
        echart = null;
        nowChart.comConfig.gridType = 3;

    },
    //图表渲染
    async rendering(chart, nowChart, dom) {
        let mapData;
        await getOption().then(async res=>{
            mapData = res.data;
        })
        let dataAll = JSON.parse(JSON.stringify(chart.data.dataTabel));
        //度量维度配置
        let config = chart.setting;
        // 图表轴
        let comConfig = nowChart.comConfig;
        let echart = echarts.init(dom);
        //右侧图表配置参数
        let params = config.params;
        // 维度配置参数
        let wdParams = config.wdList;
        // 度量配置参数
        let dlParams = config.dlList;
        //维度名称
        let wd = dataAll.head.listWD;
        //度量
        let dl = dataAll.head.listZB;
        //颜色
        let colorList = JSON.parse(JSON.stringify(comColor(comConfig.colorIndex)));
        //所有的维度数据
        let dataVal = dataAll.dt;
        //更改维度数据格式
        dataVal.map((item, index) => {
            let da = {};
            for (let i in item) {
                da[i.toLowerCase()] = item[i];
            }
            dataVal[index] = da;
        });
        //限制数据长度
        let legendList = [];
        if (dataAll.dt.length > comConfig.valLength) {
            dataAll.dt.length = nowChart.comConfig.valLength;
        }
        //获取度量数据
        let dlVal = [];
        dl.map((i, index) => {
            let configDL = {};
            dlParams.map((c) => {
                if (c.name === i.filed) {
                    configDL = c;
                }
            });
            let node = {
                value: [],
                filedNmae: i.filed,
                aliasNmae: i.alias,
                config: configDL,
            };
            node.value = dataVal.map((item) => {
                if (configDL.params.customColor) {
                    colorList[index] = configDL.params.color;
                    return {
                        value: item[i.alias],
                        itemStyle: {
                            color: configDL.params.color
                        }
                    } || 0
                } else {
                    return item[i.alias] || 0
                }
            });
            dlVal.push(node);
            legendList.push(i.alias);
        });
        //获取维度数据
        let wdVal = [];
        dataVal.map((item,idx) => {
           wdVal.push([item[wd[0].alias],item[wd[1].alias]]);
        });
        let clickOut=[];
        let url='';
        let convertData = function (data) {
            if(JSON.stringify(data) !== '[]'){
                let res = [];
                let valueIndex='';
                let nameIndex='';
                for (var i = 0; i < data.length; i++) {
                    let dataValue=data[i].value;
                    let numReg = /^[0-9]+$/
                    let numRe = new RegExp(numReg);
                    for(var j = 0; j < dataValue.length; j++){
                        if (!numRe.test(dataValue[j])) {
                            nameIndex=i;
                        }else{
                            valueIndex=i;
                        }
                    }
                }
                if(nameIndex!==''){
                    let nameData=data[nameIndex].value;
                    for(var j = 0; j < nameData.length; j++){
                        if(valueIndex!=='') {
                            let valueData=data[valueIndex].value;
                            res.push({
                                name: nameData[j],
                                value: wdVal[j].concat(valueData[j])
                            });
                        }else{
                            res.push({
                                name: nameData[j],
                                value: wdVal[j]
                            });
                        }
                    }

                }else{
                    if(valueIndex!=='') {
                        let valueData=data[valueIndex].value;
                        for(var j = 0; j < valueData.length; j++){
                            res.push({
                                value: wdVal[j].concat(valueData[j])
                            });
                        }

                    }
                }
                return res;
            }else{
                let res=[];
                for(var j = 0; j < wdVal.length; j++){
                    res.push({
                        name: '',
                        value: wdVal[j]
                    });
                }
                return res;
            }
        };
        //判断数据是否超过15条  grid专用
        let isDataLengthToNum = function () {
            let min = 15;
            if (!dataAll.dt) return false;
            if (dataAll.dt.length > min) {
                return true;
            } else {
                return false;
            }
        };

        let tooltipPoint=params.tooltip;
        tooltipPoint.trigger='item';
        tooltipPoint.formatter=function (data) {
            let str='';
            if(data.data.name){
                str+='name&nbsp:&nbsp'+data.data.name + '<br/>';
            }
            if(data.data.value[2]){
                str+='value&nbsp:&nbsp'+ data.data.value[2];
            }
            return str;
        };
        let colorArr = [];
        for(let i=0;i<params.visualMap.splitNumber;i++){
            if(i<10){
                colorArr.push(colorList[i]);
            }else{
                colorArr.push(colorList[9]);
            }
        }
        params.visualMap.inRange.color=colorArr;
        if(params.visualMap.showpieces){
            params.visualMap.pieces.map((item,index)=>{
                item.min=Number(item.min);
                item.max=Number(item.max);
            })
        }else{
            params.visualMap.pieces = [];
        }
        let valueArrbar = convertData(dlVal);
        valueArrbar.push({value:[0, 0, 10]});
        let barSeries=[];
        if(nowChart.name.search('charts')!==-1){
           barSeries=[{
                name: 'bar3D',
                type: "bar3D",
                coordinateSystem: nowChart.name === 'charts' ? "geo3D" :  "amap",
                barSize: 1, //柱子粗细
                shading: 'lambert',
                opacity: 0.1,
                emphasis: { //当鼠标放上去  地区区域是否显示名称
                    label: {
                        show: false,
                    },
                },
                label: {
                    show: false,
                    formatter: function(data) {
                        //                        console.log(data)
                        var res = data.name + " " + data.value[2]
                        return res
                    }
                },
                data:valueArrbar
            }];
        }else{
            barSeries =[];
        }
        if(params.map.mapinfo.name){
            clickDown(params.map.mapinfo.name, mapData,params,tooltipPoint,echart,nowChart,barSeries,3,valueArrbar);
            if(params.map.mapinfo.acroutes==null){
                clickOut[0] ='全国';
            }else{
                if(params.map.mapinfo.acroutes.length==2){
                    clickOut[2]=params.map.mapinfo.name;
                    for(var key in mapData){
                        if(params.map.mapinfo.parent.adcode == key){
                            clickOut[1] = mapData[key].name;
                            clickOut[0] ='全国';
                        }
                    }
                }else if(params.map.mapinfo.acroutes.length==1){
                    clickOut[1]=params.map.mapinfo.name;
                    clickOut[2]='';
                    clickOut[0] ='全国';
                }
            }
        }else{
            clickOut[0] = params.map.name;
            clickDown(clickOut[0], mapData,params,tooltipPoint, echart,nowChart,barSeries,3,valueArrbar);
        }
        renderEvent(echart,clickOut,mapData,params,tooltipPoint,nowChart,barSeries,3,valueArrbar);
    }
}


